<template>
  <div>通过inject获取值:{{ ak }}</div>
</template>

<script setup lang="ts">
  import { inject } from 'vue';
  defineOptions({
    name: 'ZnTest'
  })
  const ak = inject('znmapAk');
</script>

<style scoped lang="scss"></style>
